<template>
  <CInfoBadge
    v-if="shouldDisplay"
    :background-color="metadataProperty.background_color ?? themeVars.info"
    :color="metadataProperty.color ?? themeVars.info2"
    v-bind="getCustomIndicatorIconProps(metadataProperty.icon)"
    :text="metadataProperty.text"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CInfoBadge from '@lib/components/CInfoBadge/CInfoBadge.vue'

import useThemeVars from '@lib/composables/useThemeVars'

import { getFontAwesomeIconNameAndType } from '@lib/util/font.util'
import type { MetadataHighlightProperty } from '@lib/types/metadataHighlightProperty'

const props = defineProps<{
  item: { [key: string]: any; id: number | string }
  metadataProperty: MetadataHighlightProperty
}>()

const themeVars = useThemeVars()

const shouldDisplay = computed(() => {
  const metadataValue = props.item.metadata?.[props.metadataProperty.key]

  if (metadataValue === undefined) return false

  if (typeof metadataValue === 'boolean') {
    return metadataValue === props.metadataProperty.match_value
  }

  if (Array.isArray(metadataValue)) {
    return metadataValue.includes(props.metadataProperty.match_value)
  }

  return metadataValue === props.metadataProperty.match_value
})

function getCustomIndicatorIconProps(icon?: string) {
  const iconInfo = getFontAwesomeIconNameAndType(icon ?? 'fas bolt')
  return {
    faType: iconInfo.type,
    icon: iconInfo.name,
  }
}
</script>
